import React, { useState } from 'react';
import { Button, Form, message } from 'antd';
import CommonCard from '../../../global/card';
import CommonForm from '../../../global/form';
import SOURCES from '../../../../utils/constants';
import { useKey } from '../../../../services/useKey';
import LocalStorageService from '../../../../utils/localStorageServices';
import dayjs from 'dayjs';
import { useDestinations } from '../../../../queries/common/use-destinations';

const localStorageServices = LocalStorageService.getService();

const EnhancedAdvanceSearchLeadsSent = ({
    setShowAdvanceSearch,
    setAdvanceSearch,
    advanceSearch,
    getAdvanceSearchData,
}) => {
    const [searched, setSearched] = useState(false);
    const [form] = Form.useForm();
    const currentUser = localStorageServices.getCurrentUser();

    const { data: destinations } = useDestinations();

    const getDestinationOptions = () => {
        if (Array.isArray(destinations) && destinations.length > 0) {
            return destinations.map((item) => ({
                label: item.integrationCompany,
                value: item.integrationCompany,
            }));
        }
        return [];
    };

    useKey(() => setSearched(true), "Enter");
    useKey(() => {
        setShowAdvanceSearch(false);
        setAdvanceSearch({
            ...advanceSearch,
            advance_search_enabled: searched
                ? SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_CLOSED_SEARCH_FORM
                : SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
        });
    }, "Escape");

    const onSearch = () => {
        form
            .validateFields()
            .then(async (values) => {
                const hasValues =
                    values.startDate ||
                    values.endDate ||
                    values.destination ||
                    values.searchTerm;

                if (!hasValues) {
                    setAdvanceSearch({
                        ...advanceSearch,
                        advance_search_enabled:
                            SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                    });
                    message.error("Please fill at least one field.");
                    return;
                }

                const userTZ = dayjs.tz.guess();

                setAdvanceSearch({
                    ...advanceSearch,

                    startDate: values.startDate
                        ? dayjs(values.startDate)
                            .tz(userTZ)
                            .startOf("day")
                            .format()
                        : "",

                    endDate: values.endDate
                        ? dayjs(values.endDate)
                            .tz(userTZ)
                            .endOf("day")
                            .format()
                        : "",

                    destination: values.destination || "",
                    searchTerm: values.searchTerm || "",

                    advance_search_enabled:
                        SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_FILTER,
                });
            })
            .catch((err) => {
                console.log("Validation failed", err);
            });
    };


    const formData = [
        {
            label: "Start Date",
            name: "startDate",
            inputType: SOURCES.FORMINPUTTYPES.DATE,
            type: "date",
            placeholder: "Start Date",
            required: false,
            span: 12,
        },
        {
            label: "End Date",
            name: "endDate",
            inputType: SOURCES.FORMINPUTTYPES.DATE,
            type: "date",
            placeholder: "End Date",
            required: false,
            span: 12,
        },
        {
            label: "Destination",
            name: "destination",
            inputType: SOURCES.FORMINPUTTYPES.SELECT,
            type: "select",
            placeholder: "Filter Via Destination",
            required: false,
            options: getDestinationOptions(),
            span: 24,
        },
        {
            label: "Search",
            name: "searchTerm",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "text",
            placeholder: "Enter Name, Email or Phone",
            required: false,
            span: 24,
        }
    ];

    return (
        <CommonCard
            title="Advance Search"
            isExtraButton={{
                show: [
                    "startDate",
                    "endDate",
                    "destination",
                    "searchTerm",
                ].some((key) => advanceSearch[key] && advanceSearch[key] !== ""),
                data: [
                    {
                        title: "Clear",
                        onClick: () => {
                            setAdvanceSearch({
                                ...advanceSearch,
                                startDate: "",
                                endDate: "",
                                destination: "",
                                searchTerm: "",
                                advance_search_enabled:
                                    SOURCES.ADVANCE_SEARCH_FIELDS.SEARCH_TYPE_NOT_FILTER,
                            });
                            form.resetFields();
                        },
                    }
                ]
            }}
            className={"max-w-[650px] w-full shadow-2xl"}
        >
            <CommonForm
                data={formData}
                className="mt-4"
                layoutType="vertical"
                form={form}
            />
            <div className="flex justify-end">
                <Button
                    key="confirm"
                    type="primary"
                    className="!bg-primary text-white h-10 min-w-[130px]"
                    onClick={onSearch}
                >
                    Search
                </Button>
            </div>
        </CommonCard>
    );
};

export default EnhancedAdvanceSearchLeadsSent;
